var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useState } from 'react';
import { DocumentType, WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import SelectInput from '@shared/input/SelectInput';
import { useGrids } from '@data/grid/gridActions';
import { useDocuments } from '@data/document/documentActions';
import { useUpdateWidget, useWidgets } from '@data/widgets/widgetActions';
import { ModalBody } from '@styled/Modal';
export default function WidgetParentChangeModal(props) {
    return (React.createElement(Modal, { width: 600 },
        React.createElement(WidgetParentChangeModalForm, __assign({}, props))));
}
function WidgetParentChangeModalForm(_a) {
    var _b, _c, _d;
    var widget = _a.widget, gridId = _a.gridId;
    var isSlicer = widget.type === WidgetType.SLICER;
    var L = useLanguage().L;
    var updateWidget = useUpdateWidget();
    var documents = (_b = useDocuments().data) !== null && _b !== void 0 ? _b : [];
    var reports = documents.filter(function (d) { return d.type === DocumentType.REPORT; });
    var grids = (_c = useGrids().data) !== null && _c !== void 0 ? _c : [];
    var widgets = (_d = useWidgets().data) !== null && _d !== void 0 ? _d : [];
    var _e = __read(useState(0), 2), selectedReportId = _e[0], setSelectedReportId = _e[1];
    var _f = __read(useState(), 2), validation = _f[0], setValidation = _f[1];
    useEffect(function () {
        var currentGrid = grids.find(function (g) { return g.id === gridId; });
        if (currentGrid !== undefined) {
            setSelectedReportId(currentGrid.DocumentId);
        }
    }, [JSON.stringify(reports), JSON.stringify(grids), gridId]);
    var done = function () {
        var selectedGrid = grids.find(function (g) { return g.DocumentId === selectedReportId; });
        if (selectedGrid === undefined) {
            setValidation(L("Couldn't find grid for report"));
            return;
        }
        if (isSlicer) {
            var gridSlicer = widgets.find(function (w) { return w.GridId === selectedGrid.id && w.type === WidgetType.SLICER; });
            if (gridSlicer !== undefined) {
                setValidation(L('Report already has slicer'));
                return;
            }
        }
        updateWidget.mutate(__assign(__assign({}, widget), { GridId: selectedGrid.id }));
        Manager.closeModal();
    };
    var title = "".concat(L('Selecting report for'), " \"").concat(widget.title, "\"");
    var reportsOptions = useMemo(function () {
        return reports
            .sort(function (a, b) { var _a, _b; return ((_a = a.ParentId) !== null && _a !== void 0 ? _a : 0) - ((_b = b.ParentId) !== null && _b !== void 0 ? _b : 0); })
            .map(function (r) {
            var parentDocument = documents.find(function (d) { return d.id === r.ParentId; });
            return {
                label: "".concat(r.title, " (").concat(parentDocument !== undefined ? parentDocument.title : 'Root', ")"),
                value: r.id,
            };
        });
    }, [JSON.stringify(documents)]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(SelectInput, { name: "report", value: selectedReportId, label: L('Report'), invalid: validation !== undefined, invalidString: validation !== null && validation !== void 0 ? validation : '', onChange: function (opt) {
                        setValidation(undefined);
                        setSelectedReportId(Number(opt.target.value));
                    }, options: reportsOptions }))),
        React.createElement(ModalFooter, { done: done })));
}
